import { invoke } from '@tauri-apps/api/core';
import { isDesktopRuntime } from './rustCalculationEngine';

export interface TrustedTime {
  unixSeconds: number;
  server: string;
}

export async function getTrustedTime(): Promise<TrustedTime> {
  if (!isDesktopRuntime()) {
    throw new Error('ライセンス期間の確認にはデスクトップ版でのNTP時刻取得が必要です');
  }
  return invoke<TrustedTime>('get_trusted_time');
}

export function unixSecondsFromIso(value: string): number {
  const millis = Date.parse(value);
  if (!Number.isFinite(millis)) {
    throw new Error(`${value} は日時として解釈できません`);
  }
  return Math.floor(millis / 1000);
}

export function formatTrustedTime(unixSeconds?: number): string {
  if (!Number.isFinite(unixSeconds)) return '未確認';
  return new Date(Number(unixSeconds) * 1000).toISOString();
}
